<script setup lang="ts">
 /**
 * The phone frame. The app is mobile-only, so on a wide viewport it renders as a
 * centred column capped at `--app-max-width` rather than stretching.
 *
 * `relative` is load-bearing, not cosmetic. Every overlay in the app (drawer,
 * sheet, dialog) positions with `absolute inset-0`, which resolves against the
 * nearest positioned ancestor — this element. Drop `relative` and they resolve
 * against the viewport instead, so on a 1920px desktop the drawer would slide in
 * from the window edge while the app sits in a 448px column.
 *
 * `#app-overlay-root` uses `display: contents` rather than being a positioned box:
 * it is the teleport target for reka-ui portals, and `contents` means it never
 * generates a box of its own and so can never intercept pointer events over the
 * map when no overlay is mounted.
 */
</script>

<template>
  <div
    class="relative mx-auto flex h-dvh w-full max-w-(--app-max-width) flex-col overflow-hidden border-x border-border bg-background"
  >
    <slot />
    <div id="app-overlay-root" class="contents" />
  </div>
</template>
